import React, { useState } from "react";
// Assuming you have a CSS file for styles
// import BuildersLogo from "@components/BuildersLogo";

function SideBar({ prop }) {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const navItems = prop;
  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  return (
    <div>
      <div id="toggle-btn" onClick={toggleSidebar}>
        <span></span>
        <span></span>
        <span></span>
      </div>

      <div id="sidebar" style={{ left: isSidebarOpen ? "0px" : "-200px" }}>
        {/* <BuildersLogo className="tw-ml-12 tw-bg-white tw-m-0" /> */}
        <ul style={{ overflowY: "auto", maxHeight: "calc(100vh - 60px)" }}>
          {navItems.map((item, index) => {
            return (
              <li
                key={index}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <a
                  href={item.path}
                  className={window.location.pathname}
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  {item.icon && (
                    <item.icon
                      style={{
                        color: hoveredIndex === index ? "orange" : undefined,
                      }}
                    />
                  )}
                  <span style={{ marginLeft: "2px" }}>{item.name}</span>
                </a>
              </li>
            );
          })}
        </ul>
      </div>

      {/* Rest of your component */}
    </div>
  );
}

export default SideBar;
